"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "bardello-con-malgesso-e-bregano": {
    "6d94a2cb": [{
      "hkey": "af5a5c16",
      "slug": "le-casacce",
      "name": "Le Casacce",
      "primary": true,
      "skipSearch": false
    }],
    "00f0d532": [{
      "hkey": "b1c38f8c",
      "slug": "poiano",
      "name": "Poiano",
      "primary": true,
      "skipSearch": false
    }],
    "b890becc": [{
      "hkey": "bfeb2490",
      "slug": "roncaglia",
      "name": "Roncaglia",
      "primary": true,
      "skipSearch": false
    }],
    "5eedce70": [{
      "hkey": "4350713a",
      "slug": "costanza",
      "name": "Costanza",
      "primary": true,
      "skipSearch": false
    }],
    "c35bd47f": [{
      "hkey": "c7f0caf8",
      "slug": "bardello",
      "name": "Bardello",
      "primary": true,
      "skipSearch": false
    }],
    "eb40bd62": [{
      "hkey": "a9ee6170",
      "slug": "malgesso",
      "name": "Malgesso",
      "primary": true,
      "skipSearch": false
    }],
    "c350c316": [{
      "hkey": "de99577f",
      "slug": "bregano",
      "name": "Bregano",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;